<template>
    <div v-if="loading" class="pass-rates-chart-loading text-center">
        <b-spinner variant="primary"></b-spinner>
    </div>
</template>

<script>
export default {
  name: "ChartLoader",
  props: {
    loading: Boolean
  }
};
</script>

<style scoped>
.pass-rates-chart-loading {
  height: 100%;
  width: 100%;
  position: absolute;
  background: #f8f9fa;
}
.pass-rates-chart-loading .spinner-border {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
}
</style>
